import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo14() {
    const section = 'el-echendaro';
    const title = 'El Echéndaro';
    const description = '¡Qué onda! Después de todo lo que pasó, de repente todo se puso oscuro.';
    const text = '<p>Me desperté toda adolorida y confundida, y me di cuenta de que estaba en el exconvento de Tzintzuntzan. ¡Imagínate! Estaba lastimada, y para rematar, me di cuenta de que me había bajado por primera vez. Me dio un buen de pena, pero mi papá, con un súper amor, me abrazó y me hizo sentir que todo iba a estar bien.</p><p>Cuando salimos, vi a mi familia y a mis primos, pero la verdad es que todo se sentía raro. Mis primos no sabían quién era Taquito, ¡así que me quedé en shock! Pero luego, mi mamá me apapachó y entendió todo lo que estaba sintiendo. Me hizo ver que el camino me hizo más fuerte y que las personas que amo siempre están conmigo. Después, encontré mi teléfono, pero lo apagué. Sentía que necesitaba un descanso de tanta cosa y me puse el rebozo de mi abuelita.</p><p>Y para el final, ¡la sorpresa más bonita de todas! Mi tía me dio un regalo, un perrito xoloitzcuintle chiquito que era hijo de Taquito. Se me salieron las lágrimas porque supe que el amor de mi amigo nunca se fue y ahora lo tengo en la forma de un nuevo compañero. Lo llamé Gran Taco, y estoy segura de que tendrá un destino súper grande. Ahora, estoy en casa con mi familia, lista para el futuro.</p>';
    const image = 'https://www.diadelavida.com/images/chapters/deco_capitulo14.png?v='+Date.now();
    const image_number = 'https://www.diadelavida.com/images/numbers/14.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 400;
    const comments_prompt = 'Es el final de este capítulo en la historia de Valentina ¿Qué te pareció su viaje? ¿Qué crees que les espera a Valentina y Gran Taco? ¡Deja tu comentario!';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo14_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 14',
            description: 'Siempre con mi mejor amigo'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_grantaco_01.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 14',
            description: '¿A poco no es el xoloitzcuintle más tierno?'
        },
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}